import { getTreeControlFunctionsMissingError } from "@angular/cdk/tree";
import { DatePipe } from "@angular/common";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { Component, Inject, OnInit } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { LoggingService } from "../../../../../logging.service";
import { AssessmentCentralService } from "../../../../../shared/services/assessment-central.service";
import { CommonService } from "../../../../../shared/services/common.service";
import { FilterService } from "../../../../../shared/services/filter.service";
import { PrismService } from "../../../../../shared/services/prism.service";
import textConfiguration from "../../../../../../assets/static-text-configuration.json";

@Component({
  selector: "assessment-create-modal",
  templateUrl: "assessment-create-modal.html",
  styleUrls: ["assessment-create-modal.scss"],
  providers: [DatePipe],
})
export class AssessmentCreateModalDialogComponent implements OnInit {
  assessmentForm = new FormGroup({
    name: new FormControl("", [Validators.required]),
    owner: new FormArray([]),
    start_date: new FormControl("", [Validators.required]),
    end_date: new FormControl("", [Validators.required]),
    portfolio: new FormControl("", [Validators.required]),
    subportfolio: new FormControl("", [Validators.required]),
    program: new FormControl(""),
    project: new FormControl(""),
    vendor: new FormControl(""),
    applications: new FormControl([]),
  });
  separatorKeysCodes: number[] = [ENTER, COMMA];
  commonText: any = (textConfiguration as any).common;
  moduleName: string = (textConfiguration as any)?.modules
    ?.assessment_and_survey;
  appUserInputControl = new FormControl();
  isProjectSelected = false;
  appFilteredOptions: Observable<string[]>;
  selectedApps: any;
  selectedOwners: any = [];
  isLoading = false;
  selectedAudience: any = [];
  selectedBusinessSponsor: any = [];
  filterOptionProgram: Observable<any[]>;

  filterOptionPortfolio: Observable<any[]>;
  filterOptionSubPortfolio: Observable<any[]>;
  filterOptionProject: Observable<any[]>;
  filterOptionVendor: Observable<any[]>;

  masterInformation: any;

  filteredOptions1: any;
  filteredOptions2: any;
  filteredOptions3: any;

  options1: any;
  options2: any;
  options3: any;

  subPortOptions: any;
  subPortfilteredOptions: any;

  programOption: any;
  projectOption: any;
  vendorOption: any;
  displayLabels: any;
  openFrom: string;
  appsList: any;
  currentUser: any = {};

  constructor(
    public dialogRef: MatDialogRef<AssessmentCreateModalDialogComponent>,
    private readonly assessmentCentralService: AssessmentCentralService,
    private readonly datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly router: Router,
    private readonly prism: PrismService,
    private readonly toastrService: ToastrService,
    private readonly commonService: CommonService,
    private readonly filterService: FilterService,
    private readonly loggingService: LoggingService
  ) {}

  ngOnInit() {
    this.openFrom = this.data.openFrom || "assessment-central";
    try {
      this.currentUser = JSON.parse(localStorage.getItem("permission") ?? "{}");
    } catch (e) {
      this.currentUser = {};
    }
    if (this.openFrom === "project-central") {
      const programDetails = JSON.parse(
        localStorage.getItem("program") ?? "{}"
      );
      const selectedProjectDetails = JSON.parse(
        localStorage.getItem("selectedProject") ?? "{}"
      );
      this.assessmentForm.patchValue({
        portfolio: {
          id: programDetails.portfolio_id,
          name: programDetails.portfolio_name,
        },
        portfolio_id: programDetails.portfolio_id,
        subportfolio: {
          id: programDetails.subportfolio_id,
          name: programDetails.subportfolio_name,
        },
        subportfolio_id: programDetails.subportfolio_id,
        program: {
          id: programDetails.program_id,
          name: programDetails.program_name,
        },
        program_id: programDetails.program_id,
        project: {
          id: programDetails.project_id,
          project_name: selectedProjectDetails.project_name,
        },
        project_id: programDetails.project_id,
      });
      this.loadAppsForProject(programDetails.project_id);

      Object.keys(this.assessmentForm.controls).forEach((key) => {
        if (["portfolio", "subportfolio", "program", "project"].includes(key)) {
          const control = this.assessmentForm.get(key);
          if (control && control?.value != "") {
            control.disable();
          }
        }
      });
    }
    this.getMaster();
    this.getProgram();
    this.getProject();
    this.getVendor();
    this.getDisplayLables();
  }

  getDisplayLables() {
    this.displayLabels = this.commonService.getLabels();
  }

  async getMaster() {
    const asyncOperations: Promise<void>[] = [];

    try {
      const res: any = await this.assessmentCentralService
        .getMasterForm()
        .toPromise();
      this.masterInformation = res?.records;

      this.masterInformation?.forEach((i: any) => {
        if (i.field_name === "opportunity_portfolio") {
          this.data.portfolio = i.field_status;
          this.data.disPortfolio = i.display_name;
          asyncOperations.push(
            this.filterService
              .getPortfolioList(this.moduleName)
              .toPromise()
              .then((resp: any) => {
                this.options1 = resp.records;
                this.filteredOptions1 = this.options1;
                if (!i.field_status) {
                  this.assessmentForm.removeControl("portfolio");
                }
              })
              .catch((error) => {
                this.loggingService.error("Error fetching portfolios: ", error);
              })
          );
        }
        if (i.field_name === "opportunity_sub_portfolio") {
          this.data.subPortfolio = i.field_status;
          this.subPortOptions = i.field_values;
          this.subPortfilteredOptions = this.subPortOptions;
          this.data.disSubPortfolio = i.display_name;
          if (!i.field_status) {
            this.assessmentForm.removeControl("subportfolio");
          }
        }
      });

      await Promise.all(asyncOperations);
      this.initAutoComplete();
    } catch (error) {
      this.loggingService.error("Error fetching master form data: ", error);
    }
  }

  getProgram() {
    this.assessmentCentralService
      .getProgram(this.moduleName)
      .subscribe((res: any) => {
        this.programOption = res;
        const programControl = this.assessmentForm.get("program");
        if (programControl) {
          this.filterOptionProgram = programControl.valueChanges.pipe(
            startWith(""),
            map((value: any) => {
              if (typeof value === "string") {
                return value;
              } else {
                return value?.name;
              }
            }),
            map((name: any) => {
              if (name) {
                return this.programFilter(name);
              } else {
                return this.programOption.slice();
              }
            })
          );
        }
      });
  }

  getProject() {
    this.assessmentCentralService
      .getProject(this.moduleName)
      .subscribe((res: any) => {
        this.projectOption = res;

        const projectControl = this.assessmentForm.get("project");

        if (projectControl) {
          this.filterOptionProject = projectControl.valueChanges.pipe(
            startWith(""),
            map((value: any) =>
              typeof value === "string" ? value : value?.project_name
            ),
            map((name: string) =>
              name ? this.projectFilter(name) : this.projectOption.slice()
            )
          );

          // When project is actually SELECTED
          projectControl.valueChanges.subscribe((value: any) => {
            if (value && value.id) {
              this.isProjectSelected = true;

              // Fetch applications for selected project
              this.prism
                .getApplicationNames(`?project_id=${value.id}`)
                .subscribe((res: any) => {
                  if (res?.length > 0) {
                    this.setAppData(res);
                  } else {
                    this.setAppData([]); // clear chips if no apps
                  }
                });
            } else {
              this.isProjectSelected = false;
            }
          });
        }
      });
  }

  getVendor() {
    this.assessmentCentralService.getVendor().subscribe((res: any) => {
      this.vendorOption = res.records[0].field_values;
      const vendorControl = this.assessmentForm.get("vendor");
      if (vendorControl) {
        this.filterOptionVendor = vendorControl.valueChanges.pipe(
          startWith(""),
          map((value: any) => {
            if (typeof value === "string") {
              return value;
            } else {
              return value?.name;
            }
          }),
          map((name: any) => {
            if (name) {
              return this.vendorFilter(name);
            } else {
              return this.vendorOption.slice();
            }
          })
        );
      }
    });
  }

  onSelectionChangePortfolio(event: any) {
    const portFolioId = event.source.value.id;
    this.subPortfilteredOptions = [];
    if (!portFolioId) {
      return;
    }
    this.assessmentForm.patchValue({
      subportfolio: "",
    });

    this.filterService
      .getSubportfolioList(portFolioId, this.moduleName)
      .subscribe((resp: any) => {
        this.subPortOptions = resp.records;
        this.subPortfilteredOptions = this.subPortOptions;
        const subportfolioControl = this.assessmentForm.get("subportfolio");
        if (subportfolioControl) {
          this.filterOptionSubPortfolio = subportfolioControl.valueChanges.pipe(
            startWith(""),
            map((value: any) => {
              if (typeof value === "string") {
                return value;
              } else {
                return value?.name;
              }
            }),
            map((name: any) => {
              if (name) {
                return this.subPortfolioFilter(name);
              } else {
                return this.subPortfilteredOptions.slice();
              }
            })
          );
        }
      });
  }

  onSelectionChangeSubportfolio(e: any) {
    const subportFolioId = e.source.value.id;
    this.programOption = [];
    if (!subportFolioId) {
      return;
    }
    this.assessmentForm.patchValue({
      program: "",
    });

    this.filterService
      .getProgram(e.source.value.id, this.moduleName)
      .subscribe(async (resp: any) => {
        this.programOption = resp.records;
        const programControl = this.assessmentForm.get("program");
        if (programControl) {
          this.filterOptionProgram = programControl.valueChanges.pipe(
            startWith(""),
            map((value: any) => {
              if (typeof value === "string") {
                return value;
              } else {
                return value?.name;
              }
            }),
            map((name: any) => {
              if (name) {
                return this.programFilter(name);
              } else {
                return this.programOption.slice();
              }
            })
          );
        }
      });
  }

  onSelectionChangeProgram(e: any) {
    const programId = e.source.value.id;
    const subportfolioId: any =
      this.assessmentForm.get("subportfolio")?.value?.id;
    this.projectOption = [];
    if (!programId || !subportfolioId) {
      return;
    }
    this.assessmentForm.patchValue({
      project: "",
    });
    this.filterService
      .getProject(subportfolioId, programId, this.moduleName)
      .subscribe(async (resp: any) => {
        this.projectOption = resp.records;
        const projectControl = this.assessmentForm.get("project");
        if (projectControl) {
          this.filterOptionProject = projectControl.valueChanges.pipe(
            startWith(""),
            map((value: any) => {
              if (typeof value === "string") {
                return value;
              } else {
                return value?.name;
              }
            }),
            map((name: any) => {
              if (name) {
                return this.projectFilter(name);
              } else {
                return this.projectOption.slice();
              }
            })
          );
        }
      });
  }

  createAssessment() {
    const postdata = this.assessmentForm.getRawValue();
    postdata.user = this.selectedOwners;
    postdata.audiance = this.selectedAudience;
    postdata.business_sponsor = this.selectedBusinessSponsor;

    if (
      !this.validateRespondentAssessorRules(postdata.user, postdata.audiance, postdata.business_sponsor)
    ) {
      return;
    }

    this.isLoading = true;
    postdata.start_date = this.datePipe.transform(
      postdata.start_date,
      "YYYY-MM-dd"
    );
    postdata.end_date = this.datePipe.transform(
      postdata.end_date,
      "YYYY-MM-dd"
    );
    postdata.assessmenttemplates_id = this.data.template_id;
    postdata.portfolio_id = postdata.subportfolio.id;
    postdata.program_id = postdata.program.id;
    postdata.project_id = postdata.project.id;
    postdata.vendor_id = postdata.vendor.id;
    postdata.applications = this.selectedApps?.map((app: any) => app.id);
    this.assessmentCentralService
      .createAssessment(postdata, this.moduleName)
      .subscribe({
        next: (res: any) => {
          this.isLoading = false;
          this.dialogRef.close();
          this.toastrService.success("Assessment created successfully");
          this.router.navigateByUrl(
            "strategicRelevance/assessment-central/assessment-result/" +
              btoa(res.id + "")
          );
        },
        error: (err) => {
          this.isLoading = false;
          const backendMessage =
            err?.error?.user?.[0] ||
            err?.error?.detail ||
            "Failed to create assessment";
          this.toastrService.error(backendMessage);
        },
      });
  }

  /**
   * Enforces: assessor and respondent can never be the same person,
   * and the current user (assessment owner) can never be a respondent
   * (but may be an assessor).
   * Expects respondents/assessors as arrays of user ids or {id: ...} objects.
   */
  private validateRespondentAssessorRules(
    respondents: any[],
    assessors: any[],
    businessSponsors: any[]
  ): boolean {
    const toIds = (arr: any[]) =>
      new Set((arr || []).map((u: any) => (typeof u === "object" ? u.id : u)));

    const respondentIds = toIds(respondents);
    const assessorIds = toIds(assessors);
    const sponsorIds = toIds(businessSponsors);

    if ([...respondentIds].some((id) => assessorIds.has(id))) {
      this.toastrService.error(
        "A user cannot be both a respondent and an assessor."
      );
      return false;
    }

    if ([...respondentIds].some((id) => sponsorIds.has(id))) {
      this.toastrService.error(
        "A business sponsor cannot also be a respondent."
      );
      return false;
    }

    if (this.currentUser && respondentIds.has(this.currentUser.id)) {
      this.toastrService.error(
        "You (the assessment owner) cannot be added as a respondent."
      );
      return false;
    }

    return true;
  }

  removeApp(i: any) {
    this.selectedApps.splice(i, 1);
  }

  setAppData(appsList: any) {
    this.selectedApps = [];
    this.appsList = appsList;
    if (this.data.clause?.related_applications) {
      this.data.clause.related_applications.forEach((element: any) => {
        this.appsList.forEach((elm: any) => {
          if (elm.id === element.id) {
            this.selectedApps.push(elm);
          }
        });
      });
    }
    this.appFilteredOptions = this.appUserInputControl.valueChanges.pipe(
      startWith(""),
      map((value) => this._filterApp(value))
    );
  }

  private _filterApp(value: any): any {
    if (typeof value === "string") {
      const filterValue = value.toLowerCase();
      const removeSelected = this.appsList.filter(
        (el: any) => !this.selectedApps.includes(el)
      );
      return removeSelected.filter((app: any) =>
        app?.name?.toLowerCase().includes(filterValue)
      );
    }
    return null;
  }

  addApp(e: any) {
    this.selectedApps.push(e);
    this.appUserInputControl.setValue("");
  }

  initAutoComplete(): any {
    const portfolioControl = this.assessmentForm.get("portfolio");
    if (portfolioControl) {
      this.filterOptionPortfolio = portfolioControl.valueChanges.pipe(
        startWith(""),
        map((value: any) => {
          if (typeof value === "string") {
            return value;
          } else {
            return value?.name;
          }
        }),
        map((name: any) => {
          if (name) {
            return this.portfolioFilter(name);
          } else {
            return this.filteredOptions1.slice();
          }
        })
      );
    }
  }

  private programFilter(value: string): any {
    const filterValue = value.toLowerCase();
    return this.programOption.filter((i: any) =>
      i.name.toLowerCase().includes(filterValue)
    );
  }
  private portfolioFilter(value: string): any {
    const filterValue = value.toLowerCase();
    return this.filteredOptions1.filter((i: any) =>
      i.name.toLowerCase().includes(filterValue)
    );
  }
  private vendorFilter(value: string): any {
    const filterValue = value.toLowerCase();
    return this.vendorOption.filter((i: any) =>
      i.name.toLowerCase().includes(filterValue)
    );
  }
  private subPortfolioFilter(value: string): any {
    const filterValue = value.toLowerCase();
    return this.subPortOptions.filter((i: any) =>
      i.name.toLowerCase().includes(filterValue)
    );
  }

  private projectFilter(value: string): any {
    const filterValue = value.toLowerCase();
    return this.projectOption.filter((i: any) =>
      i.project_name.toLowerCase().includes(filterValue)
    );
  }

  private loadAppsForProject(projectId: number) {
    if (!projectId) return;

    this.isProjectSelected = true;

    this.prism
      .getApplicationNames(`?project_id=${projectId}`)
      .subscribe((res: any) => {
        if (res.length > 0) {
          this.setAppData(res);
        } else {
          this.setAppData([]);
        }
      });
  }

  displayFn(data: any) {
    if (data?.name) {
      return data.name;
    } else {
      return "";
    }
  }

  displayFnProject(data: any) {
    if (data?.project_name) {
      return data.project_name;
    } else {
      return "";
    }
  }

  userdata(e: any) {
    this.selectedOwners = e;
  }

  audiencedata(e: any) {
    this.selectedAudience = e;
  }

  businessSponsorData(e: any) {
    this.selectedBusinessSponsor = e;
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
